import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Guarantee() {
  return <AnimatedSection className="relative bg-mist-200 py-8 sm:py-10 overflow-hidden" data-id="element-120" data-mp="1o3dm4a5km9q3">
      <div aria-hidden className="pointer-events-none absolute -top-20 right-0 w-[240px] h-[240px] rounded-full bg-sage/[0.10] blur-3xl" data-id="element-121" data-mp="2223lxxjryni5" />
      <div className="relative max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122" data-mp="19ehe2d3ikwph">
        <div className="flex items-start gap-3.5 sm:gap-4" data-id="element-123" data-mp="19ceg96w4dza7">
          <span className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white border border-gold/40 flex items-center justify-center shadow-[0_2px_10px_rgba(11,27,51,0.06)]" data-id="element-124" data-mp="14gz36h5xs7eu">
            <ShieldCheck size={20} className="text-gold-deep" strokeWidth={2} data-id="element-125" data-mp="1ecsq8uha7jav" />
          </span>

          <div className="min-w-0" data-id="element-126" data-mp="qn7tn8s7gnj4">
            <h2 className="font-heading font-extrabold text-[1rem] sm:text-[1.3rem] text-navy-950 leading-tight mb-1.5" data-id="element-127" data-mp="qmet4pjuau9f">
              Explora Atlas Clínico durante 7 días
            </h2>
            <p className="text-[12.5px] sm:text-[14.5px] text-navy-800/75 leading-relaxed" data-id="element-128" data-mp="oz02jss8lwn9">
              Revisa el material con tranquilidad. Si consideras que no es para
              ti, puedes solicitar la devolución según las condiciones de
              garantía.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}